import { combineReducers } from "redux";
import isxReducer from "./store/reducers";

const rootReducer = combineReducers({
  isx: isxReducer
});

export default rootReducer;
